import React, { useState } from "react";
import { useController, useFormContext } from "react-hook-form";
import { Typography, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import { FormLabel, TextField } from ".";
import { CustomDatePicker } from "..";

type TInput =
  | "text"
  | "password"
  | "passwordCheck"
  | "date"
  | "email"
  | "phone";

function AccountInput({
  type = "text",
  name,
  label,
  placeholder,
  required = false,
  disablePatternCheck = false
}: {
  type?: TInput;
  name: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  disablePatternCheck?: boolean;
}) {
  const { control } = useFormContext();

  const {
    field,
    fieldState: { error }
  } = useController({
    name,
    control
    // rules: {
    //   required: required && `${label}을(를) 입력하세요.`,
    //   ...(disablePatternCheck && {
    //     pattern: pattern[type],
    //     ...(type === "passwordCheck" && {
    //       validate: (v, values) =>
    //         v !== values.mbr_pw ? "비밀번호가 일치하지 않습니다." : undefined
    //     })
    //   })
    // }
  });

  const [showPassword, setShowPassword] = useState(false);

  return (
    <div style={{ width: "100%" }}>
      <FormLabel>{label}</FormLabel>
      {type === "date" ? (
        <CustomDatePicker startDate={field.value} onChange={field.onChange} />
      ) : (
        <TextField
          variant="outlined"
          fullWidth
          placeholder={placeholder}
          onChange={field.onChange} // send value to hook form
          onBlur={field.onBlur} // notify when input is touched/blur
          value={field.value} // input value
          name={field.name} // send down the input name
          inputRef={field.ref} // send input ref, so we can focus on input when error appear
          error={!!error}
          type={
            type.includes("password") && !showPassword ? "password" : "text"
          }
          InputProps={{
            endAdornment: type.includes("password") && !!field.value && (
              <IconButton
                disableRipple
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? (
                  <Visibility sx={{ width: "22px", height: "22px" }} />
                ) : (
                  <VisibilityOff sx={{ width: "22px", height: "22px" }} />
                )}
              </IconButton>
            )
          }}
        />
      )}
      <Typography variant="caption" height="20px" color="error">
        {error && error.message}
      </Typography>
    </div>
  );
}

export default AccountInput;
